import Grid from '@material-ui/core/Grid';
import { styled } from '@material-ui/core/styles';

export const LoaderContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%'
});

export const NumberedFormWrapper = styled(Grid)(({ theme }) => ({
  paddingLeft: theme.spacing(1.5)
}));
